import 'jquery'
import 'bootstrap'
import 'admin-lte'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { HasError } from 'vform'
import Pagination from 'laravel-vue-pagination'

import './bootstrap'
import './registerServiceWorker'
import '@fortawesome/fontawesome-free/js/all'

import './assets/style/app.scss'
import './../node_modules/admin-lte/build/scss/AdminLTE.scss'
import money from 'v-money'

Vue.config.productionTip = false

Vue.component('has-error', HasError)
Vue.component('pagination', Pagination)

Vue.use(money, {
  precision: 2,
  decimal: ',',
  thousands: '.',
  prefix: 'R$ '
})

Vue.filter('formatMoney', function(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
